import Restaurant from 'Icons/Restaurant';
import Craft from 'Icons/Craft';
import Musee from 'Icons/Musee';
import Nature from 'Icons/Nature';
import House from 'Icons/House';
import Vacation from 'Icons/Vacation';
import Shoping from 'Icons/Shoping';
import Excursion from 'Icons/Excursion';
import Cinema from 'Icons/Cinema';
import Culture from 'Icons/Culture';
import Patrimoine from 'Icons/Patrimoine';

export const getRegionColor = (region, isTrans) => {
  switch (region) {
    case 'midelt':
      return '#653915';
    case 'zagora':
      return '#CC3301';
    case 'errachidia':
      return '#E18C3C';
    case 'ouarzazate':
      return '#829F42';
    case 'tinghir':
      return '#FFC107';
    case 'all':
      return '#653915';

    default:
      return isTrans ? 'transparent' : '#653915';
  }
};
export const getIcon = (iconName) => {
  switch (iconName?.toLowerCase()) {
    case 'restaurants':
      return <Restaurant />;
    case 'agences-de-voyage':
      return <Vacation />;
    case 'shopping':
      return <Shoping />;
    case 'artisanat':
      return <Craft />;
    case 'patrimoine':
      return <Patrimoine />;
    case 'culture':
      return <Culture />;
    case 'musee':
      return <Musee />;
    case 'excursion':
      return <Excursion />;
    case 'nature':
      return <Nature />;
    case 'hebergement':
      return <House />;
    case 'cinema':
      return <Cinema />;
    default:
      return <Restaurant />;
  }
};

export const getPhoneNumbeWithCountryCode = (number) => {
  const phoneNumber = number.toString();
  if (phoneNumber.length === 9) {
    return '+212' + phoneNumber;
  } else if (phoneNumber.length === 10 && phoneNumber.startsWith('05')) {
    return phoneNumber.replace('05', '+2125');
  } else if (phoneNumber.length === 10 && phoneNumber.startsWith('06')) {
    return phoneNumber.replace('06', '+2126');
  } else if (phoneNumber.length === 10 && phoneNumber.startsWith('07')) {
    return phoneNumber.replace('07', '+2127');
  } else if (phoneNumber.length === 12 && phoneNumber.startsWith('212')) {
    return '+' + phoneNumber;
  }

  return phoneNumber;
};

export const getDistanceWithUnit = (distance) => {
  if (distance) {
    return distance > 1000
      ? `${(distance / 1000).toFixed(1)}km`
      : `${distance.toFixed(1)}m`;
  } else {
    return 0 + 'm';
  }
};

export const getArrayCoords = (places) => {
  return places?.map((place) => ({
    latitude: place?.location.coordinates[1],
    longitude: place?.location.coordinates[0],
  }));
};

export const getcityName = (cities, slug) => {
  return cities.find((city) => city.slug === slug)?.title;
};
